<template>
  <LegalPage
    title="About Us"
    intro="gbmodshub.net is an independent information site for Android users who want to understand GB WhatsApp before downloading an APK."
    :sections="sections"
    email="contact@gbmodshub.net"
    page-name="about"
  />
</template>

<script>
import LegalPage from '@/components/LegalPage.vue';

export default {
  name: 'About',
  components: {
    LegalPage,
  },
  data() {
    return {
      sections: [
        {
          heading: 'What This Site Offers',
          paragraphs: [
            'We publish practical guidance about GB WhatsApp APK downloads, installation, features, system requirements, version history, and frequently asked questions.',
            'The site is a reference page. It is not a messaging service, official support desk, or developer page for GB WhatsApp.',
          ],
        },
        {
          heading: 'How We Present Information',
          items: [
            'Keep installation and download instructions easy to follow.',
            'Separate general information from external download providers.',
            'Describe benefits alongside risks instead of promising absolute safety.',
            'Direct readers to the contact address when they need more detail.',
          ],
        },
        {
          heading: 'Important Limits',
          paragraphs: [
            'We are not affiliated with WhatsApp Inc., Meta, or the developers of GB WhatsApp. We do not provide official software support, legal advice, or a warranty for any APK linked from this site.',
            'Each visitor should decide whether a third-party modified app is appropriate for their device and account.',
          ],
        },
      ],
    };
  },
};
</script>
